import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const DropShadow = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 2C11.3284 2 12 2.67157 12 3.5V10.5C12 11.3284 11.3284 12 10.5 12H3.5C2.67157 12 2 11.3284 2 10.5V3.5C2 2.67157 2.67157 2 3.5 2H10.5ZM11 3.5C11 3.22386 10.7761 3 10.5 3H3.5C3.22386 3 3 3.22386 3 3.5V10.5C3 10.7761 3.22386 11 3.5 11H10.5C10.7761 11 11 10.7761 11 10.5V3.5ZM13 5C13 4.72386 13.2239 4.5 13.5 4.5C13.7761 4.5 14 4.72386 14 5V6.5C14 6.77614 13.7761 7 13.5 7C13.2239 7 13 6.77614 13 6.5V5ZM13 8.5C13 8.22386 13.2239 8 13.5 8C13.7761 8 14 8.22386 14 8.5V10C14 10.2761 13.7761 10.5 13.5 10.5C13.2239 10.5 13 10.2761 13 10V8.5ZM13 12C13 11.7239 13.2239 11.5 13.5 11.5C13.7761 11.5 14 11.7239 14 12V12.5C14 13.3284 13.3284 14 12.5 14H12C11.7239 14 11.5 13.7761 11.5 13.5C11.5 13.2239 11.7239 13 12 13H12.5C12.7761 13 13 12.7761 13 12.5V12ZM10 13C10.2761 13 10.5 13.2239 10.5 13.5C10.5 13.7761 10.2761 14 10 14H8.5C8.22386 14 8 13.7761 8 13.5C8 13.2239 8.22386 13 8.5 13H10ZM6.5 13C6.77614 13 7 13.2239 7 13.5C7 13.7761 6.77614 14 6.5 14H5C4.72386 14 4.5 13.7761 4.5 13.5C4.5 13.2239 4.72386 13 5 13H6.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DropShadow
